<div class="panel-shell">
  <header class="panel-header">
    <div class="panel-title text-bold">
      {{ "UPSALE_QUESTIONS_PANEL.TITLE" | translate }}
      <span *ngIf="productName" class="panel-subtitle">{{ productName }}</span>
    </div>
    <div class="panel-header-actions flex-row-center-center">
      <div
        class="gt2-light-green flex-row-center-center"
        style="width: 60px; height: 56px"
      >
        <button
          type="button"
          matTooltip="{{ 'UPSALE_QUESTIONS_PANEL.CREATE_QUESTION' | translate }}"
          mat-icon-button
          (click)="onCreateQuestion()"
        >
          <mat-icon class="icon-mat-black">add</mat-icon>
        </button>
      </div>
      <button
        mat-icon-button
        type="button"
        class="panel-close-btn"
        (click)="close()"
        aria-label="Close panel"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </header>

  <div class="panel-body">
    <div class="flex-column">
      <mat-form-field floatLabel="auto" class="mr-4 fxFlexAuto">
        <mat-label>{{
          "UPSALE_QUESTIONS_PANEL.SEARCH" | translate
        }}</mat-label>
        <input id="search" [(ngModel)]="filterValue" matInput />
        <button
          mat-button
          *ngIf="filterValue"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="clearSearch()"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <div class="flex-row" style="margin-bottom: 16px">
        <div class="flex-column fxFlex-100p">
          <div class="pb-4 mat-caption flex-row-center-start">
            {{ "UPSALE_QUESTIONS_PANEL.LEFT_LIST_LABEL" | translate }}
          </div>
        </div>
        <div class="flex-column fxFlex-100p">
          <div class="pb-4 mat-caption flex-row-center-start">
            {{ "UPSALE_QUESTIONS_PANEL.RIGHT_LIST_LABEL" | translate }}
          </div>
        </div>
      </div>

      <div cdkDropListGroup class="flex-row">
        <!-- Questions disponibles -->
        <div
          cdkDropList
          [cdkDropListData]="available"
          (cdkDropListDropped)="onAvailableDrop($event)"
          class="ngx-dnd-container-custom mr-4 ngx-dnd-scrollable combo-list flex-column content-list fxFlex-50p"
        >
          <div
            *ngIf="isLoadingAvailable"
            class="flex-column-center-center fxFlex-100p"
          >
            <mat-spinner [diameter]="28"></mat-spinner>
          </div>

          <div
            *ngIf="!isLoadingAvailable && filteredAvailable.length === 0"
            class="flex-column-center-center fxFlex-100p combo-list-empty-message"
          >
            {{ "UPSALE_QUESTIONS_PANEL.NO_RESULTS" | translate }}
          </div>

          @for (question of filteredAvailable; track question.uuid) {
            <div
              *ngIf="!isLoadingAvailable"
              cdkDragHandle
              matRipple
              [cdkDragData]="question"
              cdkDrag
              [cdkDragDisabled]="mobileLayout.isMobileLayout()"
            >
              <div class="product-child-item flex-row-space-between-center">
                <div class="flex-row-start-center">
                  <mat-icon
                    *ngIf="!mobileLayout.isMobileLayout()"
                    class="mr-8"
                    >drag_handle</mat-icon
                  >
                  <div class="item-name-internal">{{ question.name }}</div>
                </div>
                <div class="flex-row-end-center">
                  <mat-icon class="ml-8 mr-8" (click)="onAddItem(question)"
                    >add</mat-icon
                  >
                </div>
              </div>
            </div>
          }
        </div>

        <!-- Questions attachées au produit -->
        <div
          cdkDropList
          [cdkDropListData]="attached"
          (cdkDropListDropped)="onAttachedDrop($event)"
          class="ngx-dnd-container-custom ml-4 ngx-dnd-scrollable combo-list flex-column content-list fxFlex-50p"
        >
          <div
            *ngIf="isLoadingAttached"
            class="flex-column-center-center fxFlex-100p"
          >
            <mat-spinner [diameter]="28"></mat-spinner>
          </div>

          <div
            *ngIf="!isLoadingAttached && attached.length === 0"
            class="flex-column-center-center fxFlex-100p combo-list-empty-message"
          >
            {{ "UPSALE_QUESTIONS_PANEL.NO_ATTACHED" | translate }}
          </div>

          @for (question of attached; track question.uuid) {
            <div
              *ngIf="!isLoadingAttached"
              matRipple
              cdkDragHandle
              [cdkDragData]="question"
              cdkDrag
              [cdkDragDisabled]="mobileLayout.isMobileLayout()"
            >
              <div
                class="product-child-item-right flex-row-space-between-center"
              >
                <div class="flex-row-start-center">
                  <mat-icon
                    *ngIf="!mobileLayout.isMobileLayout()"
                    class="mr-8"
                    >drag_handle</mat-icon
                  >
                  <div class="item-name-internal">{{ question.name }}</div>
                </div>
                <div class="flex-row-end-center">
                  <mat-icon class="ml-8 mr-8" (click)="onRemoveItem(question)"
                    >delete</mat-icon
                  >
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  <footer class="panel-footer flex-row-center-center">
    <button mat-raised-button (click)="close()" class="accent">
      {{ "GENERIC.OK" | translate }}
    </button>
  </footer>
</div>
